export default {"src":"/_next/static/media/icon_flag_ru.e5da6edd.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};